import React, { useEffect, useState } from "react";
import { formatDate } from "../../assets/constants/date";

type Props = {
  endTime: number;
  onEnd?: () => void;
  onClick: () => void;
};

export const Timer = ({ endTime, onEnd, onClick }: Props) => {
  const gtmDate = Date.now();
  const [milliseconds, setMilliseconds] = useState(endTime - gtmDate);
  const hasDays = milliseconds > 86400000;

  useEffect(() => {
    const interval = setInterval(() => {
      if (milliseconds < 1000) onEnd?.();
      if (milliseconds >= 1740000 && milliseconds <= 1741000) onClick();
      setMilliseconds(milliseconds - 1000);
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [milliseconds]);

  useEffect(() => {
    setMilliseconds(endTime - gtmDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endTime]);

  return (
    <>
      {formatDate(new Date(milliseconds), hasDays ? "DD" : "hhh:mm:ss")}
    </>
  );
};
